angular.module('app').config(exchangeRatesRouting);

function exchangeRatesRouting($routeProvider) {
  $routeProvider.when('/exchange_rates', {
    pageTitle: 'EXCHANGE_RATES',
    template: '<exchange-rates-page></exchange-rates-page>',
    breadcrumb: {
      label: 'COMPANY_SETTINGS',
      parent: 'ng/company_settings',
    },
    accessPermission: 'index_exchangerate_accountadmin',
    authReq: true,
  });
}

exchangeRatesRouting.$inject = ['$routeProvider'];
